import TokenService from "@/services/storage.service";

const state = {
  user: null,
  addresses: [],
  profile: {},
  bankStatement: [],
  lastBankStatement: null,
  categories: [],
  products: [],
  bestSoldProducts: [],
  seasonalProducts: [],
  soonAffordableProducts: [],
  productsMeta: {},
  productsPageNumber: 1,
  product: {},
  attribute_options: [],
  productRequestSent: false,
  categoriesRequestSent: false,
  trainings: [],
  training: {},
  questions: [],
  trainingResult: false,
  hasPoints: false,
  endQuizDate: null,
  btrainings: [],
  btraining: {},
  bTrainingDetails: [],
  bTrainingCosts: [],
  bTrainingTypes: [],
  bTrainingResult: {},
  bTrainingLoading: false,
  addressSelected: null,
  userSlides: [],
  textPages: [],
  textPage: null,
  watchedVideo: false,
  messages: [],
  messageDetail: null,
  messageDetailLoading: false,
  isPending: false,
  toast: [],
  userOrders: [],
  userOrder: null,
  userPromotions: [],
  newsFeeds: [],
  newsFeedsMeta: null,
  currentNewsFeed: null,
  userProducts: [],
  wholesalers: [],
  groups: [],
  singleHunter: {},
  prices: [],
  priceCategories: [],
  singlePriceList: [],
  vehicleTyres: [],
  pointsByCustomerNumber: [],
  investmentSupportNew: false,
  certificateTexts: [],
  profilePercentageNum: 0,
  menu: [],
  unreadMessages: 0,
  kickbackInfo: [],
  mediaCategories: [],
  singleMedia: [],
  mediaFiles: [],
  singleMediaCategory: {},
  allDealers: 0,
  wshSelect: [],
  inUnknownGroup: true,
  defaultBanners: [],
  dealerApps: [],
  permissions: [],
  paginationLinks: [],
  totalMediaFiles: 0,
  tyreLimit: 0,
  promotions: [],
  allWholesalers: [],
  brochureCategories: [],
  brochureFiles: [],
  cart: {},
  mainBoxes: [],
  fetchMenu: false,
  fetchLeftColumn: false,
  liteVersionCountries: [],
  accessRestricted: true,
  accessData: null,
  initialSurveyStep: 0,
  parentAttributes: [],
  initialParentAttributes: [],
  businessUnits: [],
  profileIsPending: false,
  meIsPending: false,
  should_fill_report_data: false,

  availableModules: [],
  tenantId: null,
  tenancyEnabled: false,
  bothRelationOptionDisabled: ["PT", "ES", "NL"],
  fleetRelationOptionDisabled: ["PT", "ES"],
  noBussinesRelationOptionDisabled: ["PT", "ES", "NL"],
  directRelationOptionDisabled: ["NL"],
  noRequiredPersonalData: [],
  currentLocale: localStorage.getItem("currentLocale"),
  aboutPage: [],
  contactService: [],
  tenantPermissions: [], // Always default to an empty array,
  tenantModuleConfigs: {},
  sliderIsLoading: false,
  canSeeCartIcon: TokenService.showElement("cartIcon.see") ?? false,
  pointBoard: null,
  dealerAppsPending: false,
  messagesIsLoading: false,
  bonusMultiplicator: [],
  pointBonusByYear: null,
  currentPoints: 0,
  currentKickbacks: 0,
};

export { state };
